<template v-show="value">

        <v-expansion-panels flat accordion v-model="expanded_panel_index" class="tw-absolute tw-top-12 lg:tw-top-16 tw-sticky">
            <v-expansion-panel>
                <v-expansion-panel-content color="alternate">
<!--                    Child component could be login/forgotPw/...-->
<!--                    Each child component should have its own reset,resetValidation methods-->
                    <component ref="AuthBarChild" v-bind:is="child_component" @view="changeView" @close="closeAuthBar"/>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

</template>

<script>

import AuthBarLogin from "@/Generic/AuthBarLogin.vue";
import AuthBar2faCode from "@/Generic/AuthBar2faCode.vue";
import AuthBarForgotPw from "@/Generic/AuthBarForgotPw.vue";
import AuthBarWelcome from "@/Generic/AuthBarWelcome.vue";

export default {
    name: "AuthBar",
    components: {AuthBarWelcome, AuthBarForgotPw, AuthBarLogin, AuthBar2faCode},

    props: {
        'value': {
            // Determines visibility of the AuthBar.  Should be used with v-model
            type: Boolean,
            required: true,
        },
    },

    data: () => ({
        expanded_panel_index: null,
        child_component:"AuthBarLogin",
    }),

    methods: {
        reset () {
            this.child_component= "AuthBarLogin"
            this.expanded_panel_index = null
            this.$nextTick(()=>{
                this.$refs.AuthBarChild.reset()
            })
        },
        resetValidation () {
            this.$refs.AuthBarChild.resetValidation()
        },
        closeAuthBar () {
            this.$emit('input', false)
        },
        changeView (newView) {
            this.child_component = newView
            this.resetValidation()
        }
    },

    watch: {
        value: {
            handler(newVal, oldVal) {
                if (newVal) {
                    // Opening AuthBar
                    this.expanded_panel_index = 0
                } else {
                    // Closing AuthBar
                    this.reset()
                }
            }
        },
    }
}
</script>
<style scoped>

</style>
